import CompanyDetails from './organisation/1-company-details';
import ReRouter from "../rerouter";

const StageRouter = ({ application, updateState, addToStore, previousStep, nextStep, steps, changeStage }) => {
  for (const step of steps) {
    if (step.name === application.step) {
      const StepComponent = step.component;
      return (
        <ReRouter addToStore={addToStore} changeStage={changeStage} nextStep={nextStep}>
          <StepComponent
            state={application}
            addToStore={addToStore}
            updateState={updateState}
            nextStep={nextStep}
            previousStep={previousStep}
            changeStage={changeStage}
          />
        </ReRouter>
      )
    }
  }

  return (
    <ReRouter addToStore={addToStore} changeStage={changeStage} nextStep={nextStep}>
      <CompanyDetails
        state={application}
        addToStore={addToStore}
        updateState={updateState}
        nextStep={nextStep}
      />
    </ReRouter>
  )
}

export default StageRouter;
